if (!customElements.get("section-selected")) {
  customElements.define(
    "section-selected",
    class SectionSelected extends HTMLElement {
      constructor() {
        super();
        this.titleSelect = this.querySelector(".title-select");
        this.titleSelectText = this.querySelector(".title-select__text");
        this.titleList = this.querySelector(".title-list");
        this.titleItems = this.querySelectorAll(".title-item");
        this.collectionSelect = this.querySelector(".collection-select");
        this.collectionSelectText = this.querySelector(
          ".collection-select__text"
        );
        this.titleGroups = this.querySelectorAll(".title-group");
        this.collectionList = this.querySelector(".collection-list");
        this.collectionItems = this.querySelectorAll(".collection-item");
        this.collectionGroups = this.querySelectorAll(".collection-group");

        this.firstButton = this.querySelector(".btn-change-url");
        this.isProductTemplate =
          document.body?.classList.contains("template-product");
        this.handleFirstButtonClick = this.handleFirstButtonClick.bind(this);

        this.init();
      }

      init() {
        this.setupAccessibility();
        if (this.isProductTemplate || this.hasCustomVariantTarget()) {
          this.setupFirstButtonAsAddToCart();
        }

        if (this.titleGroups.length > 0) {
          const firstTitleGroup = this.titleGroups[0];
          const firstTitleItem = firstTitleGroup.querySelector(".title-item");
          if (firstTitleItem) {
            firstTitleGroup.classList.add("active");
            this.selectTitle(firstTitleItem, false);
          }
        }

        if (this.collectionItems.length > 0) {
          const firstCollectionItem = this.collectionItems[0];
          firstCollectionItem.classList.add("active");
          this.selectCollection(firstCollectionItem, false);
        }

        if (this.titleSelectText) {
          this.titleSelectText.addEventListener("click", () =>
            this.handleTitleToggle()
          );
          this.titleSelectText.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.handleTitleToggle();
            }
          });
        }

        if (this.collectionSelectText) {
          this.collectionSelectText.addEventListener("click", () =>
            this.handleCollectionToggle()
          );
          this.collectionSelectText.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.handleCollectionToggle();
            }
          });
        }

        this.titleItems.forEach((item, index) => {
          item.setAttribute("tabindex", "0");
          item.setAttribute("id", `title-item-${index}`);

          item.addEventListener("click", () => this.selectTitle(item));
          item.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.selectTitle(item);
            } else if (e.key === "ArrowDown") {
              e.preventDefault();
              const nextItem = this.titleItems[index + 1] || this.titleItems[0];
              nextItem.focus();
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              const prevItem =
                this.titleItems[index - 1] ||
                this.titleItems[this.titleItems.length - 1];
              prevItem.focus();
            } else if (e.key === "Escape") {
              e.preventDefault();
              this.closeDropdown(this.titleList);
              this.titleSelectText.focus();
            }
          });
        });

        this.collectionItems.forEach((item, index) => {
          item.setAttribute("tabindex", "0");
          item.setAttribute("id", `collection-item-${index}`);

          item.addEventListener("click", () => this.selectCollection(item));
          item.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.selectCollection(item);
            } else if (e.key === "ArrowDown") {
              e.preventDefault();
              const visibleItems = Array.from(this.collectionItems).filter(
                (i) => i.closest(".collection-group").style.display !== "none"
              );
              const currentIndex = visibleItems.indexOf(item);
              const nextItem =
                visibleItems[currentIndex + 1] || visibleItems[0];
              nextItem.focus();
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              const visibleItems = Array.from(this.collectionItems).filter(
                (i) => i.closest(".collection-group").style.display !== "none"
              );
              const currentIndex = visibleItems.indexOf(item);
              const prevItem =
                visibleItems[currentIndex - 1] ||
                visibleItems[visibleItems.length - 1];
              prevItem.focus();
            } else if (e.key === "Escape") {
              e.preventDefault();
              this.closeDropdown(this.collectionList);
              this.collectionSelectText.focus();
            }
          });
        });

        document.addEventListener("click", (event) => {
          if (!event.target.closest("select-options")) {
            this.closeAllDropdowns();
          }
        });
        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            this.closeAllDropdowns();
          }
        });
        window.addEventListener("resize", () => {
          this.checkAllDropdownPositions();
        });
        const viewportWidth = window.innerWidth;
        if (viewportWidth <= 767) {
          this.checkAllDropdownPositions();
        }
      }

      checkAllDropdownPositions() {
        document.querySelectorAll(".collection-group").forEach((group) => {
          if (group.style.display !== "none") {
            this.checkDropdownPosition(group);
          }
        });
        this.checkDropdownPosition(this.titleList);
      }

      setupAccessibility() {
        if (this.titleSelect) {
          this.titleSelectText.setAttribute("tabindex", "0");
        }

        if (this.collectionSelect) {
          this.collectionSelectText.setAttribute("tabindex", "0");
        }
      }

      setupFirstButtonAsAddToCart() {
        if (!this.firstButton) return;
        if (this.hasStaticLink()) return;
        if (!this.hasCustomVariantTarget()) {
          this.firstButton.setAttribute("href", "#");
        }
        this.firstButton.setAttribute("role", "button");
        this.firstButton.removeAttribute("aria-disabled");
        this.firstButton.addEventListener("click", this.handleFirstButtonClick);
      }

      hasCustomVariantTarget() {
        return Boolean(
          this.firstButton?.getAttribute("data-selected-variant-id")
        );
      }

      hasStaticLink() {
        return this.firstButton?.getAttribute("data-static-link") === "true";
      }

      addCustomProductToCart(variantId) {
        if (!variantId) return;
        if (
          this.firstButton &&
          this.firstButton.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        const addToCartUrl = window.routes?.cart_add_url || "/cart/add";
        const addToCartApiUrl = addToCartUrl.endsWith(".js")
          ? addToCartUrl
          : `${addToCartUrl}.js`;
        const cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("main-cart");

        if (this.firstButton) {
          this.firstButton.setAttribute("aria-disabled", "true");
        }

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");

        if (cart && typeof cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }

        fetch(addToCartApiUrl, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response?.status) {
              return;
            }

            if (
              cart &&
              typeof cart.renderContents === "function" &&
              response?.sections
            ) {
              cart.renderContents(response);
            }

            if (cart && cart.tagName === "CART-DRAWER") {
              const cartTrigger =
                document.getElementById("cart-icon-bubble") || this.firstButton;
              if (typeof cart.onShowCartDrawer === "function") {
                cart.onShowCartDrawer(
                  {
                    preventDefault() {},
                  },
                  cartTrigger
                );
              } else if (cartTrigger && typeof cartTrigger.click === "function") {
                  cartTrigger.click();
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            if (this.firstButton) {
              this.firstButton.removeAttribute("aria-disabled");
            }
          });
      }

      handleFirstButtonClick(event) {
        const selectedVariantId = this.firstButton?.getAttribute(
          "data-selected-variant-id"
        );

        if (selectedVariantId) {
          event.preventDefault();
          this.addCustomProductToCart(selectedVariantId);
          return;
        }

        if (!this.isProductTemplate) return;
        event.preventDefault();

        const mainProductForm =
          document.querySelector(".main-product-form:not(.form-sticky-add-cart)") ||
          document.querySelector(".main-product-form") ||
          document.querySelector('form[data-type="add-to-cart-form"]');

        if (!mainProductForm) return;

        const submitButton =
          mainProductForm.querySelector('[type="submit"][name="add"]') ||
          mainProductForm.querySelector('[type="submit"]');

        if (
          submitButton?.disabled ||
          submitButton?.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        if (typeof mainProductForm.requestSubmit === "function") {
          mainProductForm.requestSubmit();
          return;
        }

        if (submitButton) {
          submitButton.click();
          return;
        }

        mainProductForm.submit();
      }

      updateFirstButtonUrl(url) {
        if (
          this.isProductTemplate ||
          this.hasCustomVariantTarget() ||
          this.hasStaticLink() ||
          !this.firstButton ||
          !url
        ) {
          return;
        }
        this.firstButton.href = url;
      }

      handleTitleToggle() {
        this.toggleDropdown(this.titleList);
        if (this.collectionList?.classList.contains("active")) {
          this.closeDropdown(this.collectionList);
        }
      }

      handleCollectionToggle() {
        this.toggleDropdown(this.collectionList);
        if (this.titleList?.classList.contains("active")) {
          this.closeDropdown(this.titleList);
        }
      }

      sanitizeTitle(text = "") {
        return text.replace(/\bMD\b/gi, "").replace(/\s{2,}/g, " ").trim();
      }

      selectTitle(item, shouldFocus = true) {
        const blockId = item.getAttribute("data-block-id");
        const title = this.sanitizeTitle(item.textContent);
        const defaultUrl = item.getAttribute("data-default-url");
        let selectedUrl = defaultUrl || "";

        this.titleGroups.forEach((group) => {
          const groupItem = group.querySelector(".title-item");
          if (
            groupItem &&
            groupItem.getAttribute("data-block-id") === blockId
          ) {
            group.classList.add("active");
          } else {
            group.classList.remove("active");
          }
        });

        this.titleSelectText.textContent = title;
        this.titleSelectText.appendChild(this.createSvgIcon());
        this.collectionGroups.forEach((group) => {
          if (group.id === blockId) {
            group.style.display = "flex";
            const firstCollectionItem = group.querySelector(".collection-item");
            if (firstCollectionItem) {
              const collectionTitle = firstCollectionItem.textContent.trim();
              const collectionUrl =
                firstCollectionItem.getAttribute("data-url");

              selectedUrl = collectionUrl || selectedUrl;
              if (this.collectionSelectText) {
                this.collectionSelectText.textContent = collectionTitle;
                this.collectionSelectText.appendChild(this.createSvgIcon());
                this.collectionSelectText.setAttribute("data-url", collectionUrl);
              }
              this.collectionItems.forEach((item) =>
                item.classList.remove("active")
              );
              firstCollectionItem.classList.add("active");
            }
          } else {
            group.style.display = "none";
          }
        });
        this.updateFirstButtonUrl(selectedUrl);

        this.closeDropdown(this.titleList);
        if (shouldFocus) {
          this.titleSelectText.focus();
        }
      }

      createSvgIcon() {
        const svg = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );
        svg.setAttribute("width", "13");
        svg.setAttribute("height", "7");
        svg.setAttribute("viewBox", "0 0 13 7");
        svg.style.setProperty("--width", "1.3rem");
        svg.classList.add(
          "icon",
          "icon-down",
          "icon-rotate",
          "transition-drawer",
          "w-custom",
          "flex-auto"
        );
        const use = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "use"
        );
        use.setAttribute("href", "#icon-arrow-down-mb");
        svg.appendChild(use);
        return svg;
      }

      selectCollection(item, shouldFocus = true) {
        const title = item.textContent.trim();
        const url = item.getAttribute("data-url");

        this.collectionItems.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");

        this.collectionSelectText.textContent = title;
        this.collectionSelectText.appendChild(this.createSvgIcon());
        this.collectionSelectText.setAttribute("data-url", url);

        this.updateFirstButtonUrl(url);

        this.closeDropdown(this.collectionList);
        if (shouldFocus) {
          this.collectionSelectText.focus();
        }
      }

      toggleDropdown(dropdown) {
        const isExpanded = dropdown?.classList.toggle("active");
        if (dropdown === this.titleList) {
          if (isExpanded) {
            this.checkDropdownPosition(dropdown);
            setTimeout(() => {
              const firstItem = dropdown.querySelector(".title-item");
              if (firstItem) firstItem.focus();
            }, 100);
          }
        } else if (dropdown === this.collectionList) {
          if (isExpanded) {
            this.checkDropdownPosition(dropdown);
            setTimeout(() => {
              const visibleGroup = Array.from(this.collectionGroups).find(
                (g) => g.style.display !== "none"
              );
              if (visibleGroup) {
                const firstItem =
                  visibleGroup.querySelector(".collection-item");
                if (firstItem) firstItem.focus();
              }
            }, 100);
          }
        }
      }

      checkDropdownPosition(dropdown) {
        if (!dropdown) return;

        const viewportWidth = window.innerWidth;
        const parentDropdown = dropdown.closest(".collection-list");
        dropdown.classList.remove(
          "dropdown-right",
          "dropdown-left",
          "dropdown-mobile"
        );

        if (viewportWidth <= 767) {
          dropdown.classList.add("dropdown-mobile");
          const dropdownRect = dropdown.getBoundingClientRect();

          if (dropdownRect.right > viewportWidth) {
            dropdown.classList.add("dropdown-right");
            if (parentDropdown != null) {
              parentDropdown.classList.add("dropdown-right");
            }
          }

          if (dropdownRect.left < 0) {
            dropdown.classList.add("dropdown-left");
            if (parentDropdown != null) {
              parentDropdown.classList.add("dropdown-left");
            }
          }
        } else {
          this.removeClassPosition(dropdown);
          if (parentDropdown != null) {
            this.removeClassPosition(parentDropdown);
          }
        }
      }

      closeDropdown(dropdown) {
        if (!dropdown) return;
        dropdown.classList.remove("active");
      }

      removeClassPosition(dropdown) {
        if (!dropdown) return;
        dropdown.classList.remove(
          "dropdown-right",
          "dropdown-left",
          "dropdown-mobile"
        );
      }

      closeAllDropdowns() {
        this.closeDropdown(this.titleList);
        this.closeDropdown(this.collectionList);
      }
    }
  );
}
